import React, { useEffect } from 'react'


function useTitle(title){
    useEffect(() => {
        const suffix = 'Windmar Shifter'
        document.title = title ? `${title} | ${suffix}` : suffix;
    }, [title])
}


export default useTitle;